<template>
  <a-card :title="title" style="margin-top: 1em;">
    <a-collapse :active="activeKey">
      <a-collapse-panel
        :header="`${question.idx === 'notice' ? '(공지) ': ' ' }${question.title} - ${question.author.username}`"
        v-for="question in questions"
        :key="question.idx"
      >
        <BroadcastAdminCard
          :idx="question.idx"
          :title="question.title"
          :contents="question.contents"
          :uploadAt="question.uploadAt"
          :author="question.author"
          :answer="question.answer"
          @refresh="onRefresh"
        />
      </a-collapse-panel>
    </a-collapse>
  </a-card>
</template>
<script>
import BroadcastAdminCard from "./BroadcastAdminCard";

export default {
  name: "BroadcastAdmin",
  props: ["title", "questions"],
  components: { BroadcastAdminCard },
  data() {
    return { activeKey: "" };
  },
  methods: {
    onRefresh() {
      this.$emit("refresh");
    }
  }
};
</script>